import React, { useState } from 'react'
import classNames from 'classnames'

import styles from './icon_row.module.sass'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import ScrollAnimation from './layout/scroll_animation'
import Button from './basic/button'
import Counter from './misc/counter'

function IconRow(props) {
	const fields = props.fields
	const [key, setKey] = useState(0)
	
	//used to force the counter to animate when the icon row is activated in a tabbed content component
	if (props.active && key === 0) {
		setKey(1)
	}

	return <BlockWrapper {...props} className={classNames(styles.icon_row, styles[fields.style])}>
			<ScrollAnimation styles={styles}>
				<div className={styles.icon_row_wrapper}>
					{fields.icon.url && <Image className={classNames(styles.icon, fields.icon_size && styles[fields.icon_size])} {...fields.icon} />}
					<div className={styles.content_wrapper}>
						{fields.counter && 
							<div className={styles.counter}>
								<Counter key={key} end={fields.counter} repeat={false} seconds={.5} delay={Math.random() * .2} />
							</div>
						}
						<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}}></div>
						{fields.button.url && 
							<Button className={styles.button} fields={{button: fields.button, button_style: fields.button_style, button_color: fields.button_color}}>{fields.button.title}</Button>
						}
					</div>
				</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default IconRow